import { differenceInDays, formatDistance, fromUnixTime, isAfter, isValid } from "date-fns/esm";
import { useEffect, useState } from "react";

const TRIAL_REFRESH_INTERVAL_MS = 10_000;

const getTrialEndDate = (onTrialUntil?: number) => {
  if (!onTrialUntil) {
    return undefined;
  }

  const trialEndDate = fromUnixTime(onTrialUntil);

  return isValid(trialEndDate) ? trialEndDate : undefined;
};

const getTrialDaysLeft = (trialEndDate?: Date) =>
  trialEndDate ? differenceInDays(trialEndDate, new Date()) : 0;

const getTrialEndDistanceInDays = (trialEndDate?: Date) =>
  trialEndDate ? formatDistance(trialEndDate, new Date()) : undefined;

const useTrialTime = (onTrialUntil?: number) => {
  const trialEndDate = getTrialEndDate(onTrialUntil);

  const [trialDaysLeft, setTrialDaysLeft] = useState(() => getTrialDaysLeft(trialEndDate));

  const [distanceInDays, setDistanceInDays] = useState(() =>
    getTrialEndDistanceInDays(trialEndDate)
  );

  const isTrialFinished = !trialEndDate || isAfter(new Date(), trialEndDate);

  useEffect(() => {
    if (isTrialFinished) {
      return;
    }

    const trialInterval = setInterval(() => {
      const currentTrialEndDate = getTrialEndDate(onTrialUntil);

      setTrialDaysLeft(getTrialDaysLeft(currentTrialEndDate));
      setDistanceInDays(getTrialEndDistanceInDays(currentTrialEndDate));
    }, TRIAL_REFRESH_INTERVAL_MS);

    return () => {
      clearInterval(trialInterval);
    };
  }, [isTrialFinished, onTrialUntil]);

  return { trialDaysLeft, distanceInDays, isTrialFinished };
};

export default useTrialTime;
